const userApps = {
  userApps: 'Admin user apps',
  showing: 'showing',
  userAppsOf: 'apps of',
  noUserAppsFound: 'No user apps found',
};

export default userApps;
